import { render } from "./UsersOverview.vue?vue&type=template&id=9a9efbc2"
import script from "./UsersOverview.vue?vue&type=script&lang=js"
export * from "./UsersOverview.vue?vue&type=script&lang=js"

import "./UsersOverview.vue?vue&type=style&index=0&id=9a9efbc2&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.35_typescript@4.9.5__webpack@5.107.2_postcss@8.5.8_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__